import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import {
  NotifyTypingInput,
  PublishNotificationResponse,
} from "../models/team/notification";

export const TeamNotificationGroup = HttpApiGroup.make("team-notification")
  .add(
    HttpApiEndpoint.post("notifyTyping", "/notifications/typing")
      .middleware(Authorization)
      .setPayload(NotifyTypingInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
